import { Component, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';

import { GfTranslateService } from '../../../services/core.translate.service';
import { BreadcrumbService } from '../../../../widgets/breadcrumbs/breadcrumbs.service';


const localTranslations = {
    'Pending' : 'Pendiente',
    'This project is still pending approval' : 'Este proyecto todavía está pendiente de aprobación',
    'Active' : 'Activo',
    'On Hold' : 'Suspendido',
    'Public' : 'Público',
    'This project is visible to the public': 'Este proyecto es visible para todos los usuarios',
    'Private' : 'Privado',
    'This is a private project, only accessible to members' :
    'Este proyecto es prviado, solo visible para sus miembros'
};
@Component({
    selector: 'project-header',
    template: require('./project.header.html')
})
export class ProjectHeaderComponent implements OnInit {

    @Input() project: any = null;
    @Input() projectMenu: any = null;

    protected crumbs;

    constructor(
        private gfTranslateService: GfTranslateService,
        private breadcrumbService: BreadcrumbService,
        private stateService: StateService
    ) {
        this.gfTranslateService.setStrings('es', localTranslations);
    }
    
    ngOnInit() {
        this.crumbs = this.breadcrumbService.getCrumbs();

        const onCrumbsChange = (newCrumbs) => {
            this.crumbs = newCrumbs;
        };

        this.breadcrumbService.onCrumbsChange(onCrumbsChange);
    }

    projectStatusClass = (status) => {
        switch (status) {
            case 0:
                return 'alert-danger';
            case 1:
                return 'alert-success';
            default:  // include 3 = on hold/deleted
                return 'alert-warning';
        }
    };

    /**
     * ToDo: This is a temporary fix to allow internal project sections to hide the main project header
     */
    get shouldShowHeader(): boolean {
        const current = this.stateService.current;
        const data = current && current.data;
        if (data && Object.prototype.hasOwnProperty.call(data, 'showProjectHeader')) {
            return !!data.showProjectHeader;
        }
        return this.stateService.is('home.project.summary');
    }
}
